/* StartupAppendage.js */

"use strict";
const _ = require("lodash");
const {isValidUrlForStorage} = require("../utils/url-validator");

class StartupAppendage {
    /**
     * @param logger
     * @param steveCore
     * @param userSession
     * @param router
     * @param muf
     * @param {UserLocalStorage} localStorage
     */
    constructor(logger, steveCore, userSession, router, muf, localStorage, ControlUser) {
        this._logger = logger;
        this._steve = steveCore;
        this._userSession = userSession;
        this._router = router;
        this._muf = muf;
        this._localStorage = localStorage;
        this._ControlUser = ControlUser;
    }

    startUp(opts) {
        let routeData = this._router.getRouteData();

        //Look for an override
        let override;
        try {
            override = this._steve.di.getRegistered("$eededBits.credentials");
        } catch (e) {
            //whatevs
        }

        let creds;
        if (override) {
            creds = override.registeredObj;
        } else {
            const token = _.get(
                routeData,
                "token",
                _.get(opts, ["newRouteDetails", "rd", "token"], this._localStorage.getToken())
            );
            if (token) {
                creds = {username: "OTK", password: token};
            } else if (routeData && routeData.username && routeData.password) {
                //Look for username / password in the routedata
                creds = {username: routeData.username, password: routeData.password};
            }
        }

        let routeDestSection = _.get(opts, "newRouteDetails.s", false);
        const redirect = _.get(
            opts,
            "newRouteDetails.rd.redirect",
            _.get(opts, "newRouteDetails", false)
        );
        if (_.get(redirect, "rd.redirect")) {
            redirect.rd.redirect = null;
        }

        return Promise.resolve()
            .then(() => {
                // if we have auth data, try to login and reroute to dashboard on success
                if (creds) {
                    return this._userSession
                        .login(creds)
                        .then(() => {
                            return this._ControlUser.loadControlUser(
                                this._userSession.user.tenantId,
                                this._userSession.user.id
                            );
                        })
                        .then((controluser) => {
                            const loadPath = window.localStorage.getItem("loadpath");
                            if (loadPath) {
                                window.localStorage.removeItem("loadpath");
                                window.location = loadPath;
                                return;
                            }
                            if (redirect) {
                                this._router.goTo(redirect);
                                return false;
                            } else if (routeDestSection && routeDestSection !== "LoginCenter") {
                                if (!controluser) {
                                    this._logger.warn("Control User not available");
                                }
                                let solnUrl = _.get(opts, "newRouteDetails.url", false);
                                if (solnUrl) {
                                    solnUrl = solnUrl.split("#!")[1];
                                }
                                if (
                                    controluser &&
                                    solnUrl &&
                                    solnUrl.toLowerCase().search("fail") < 0 &&
                                    solnUrl.toLowerCase().search("banner") < 0 &&
                                    solnUrl.toLowerCase().search("eula") < 0 &&
                                    solnUrl.toLowerCase().search("robohelp") < 0 &&
                                    solnUrl.toLowerCase().search("passwordreset") < 0 &&
                                    solnUrl.toLowerCase().search("logincenter") < 0 &&
                                    solnUrl.toLowerCase().search("logoutcenter") < 0 &&
                                    solnUrl !== controluser.lastRoute
                                ) {
                                    controluser.setLastRoute(solnUrl);
                                    controluser.update();
                                    window.sessionStorage.setItem(
                                        this._userSession.user.id + "lastPathInfo",
                                        solnUrl
                                    );
                                }
                                return true;
                            } else if (
                                routeDestSection &&
                                (routeDestSection === "Eula" || routeDestSection === "Banner")
                            ) {
                                return true;
                            }
                            let lastPathInfo = window.sessionStorage.getItem(
                                this._userSession.user.id + "lastPathInfo"
                            );
                            if (lastPathInfo) {
                                if (lastPathInfo.search("/s/Perspective/") >= 0) {
                                    window.location.href =
                                        window.origin + "/_app_/gluware_control/#!" + lastPathInfo;
                                    return;
                                } else {
                                    window.location.hash = "#!" + lastPathInfo;
                                    return;
                                }
                            }
                            this._router.goTo({
                                app: "GameConsole",
                                s: "Dashboard",
                                rd: {triggeredBy: "Startup"},
                            });
                            return false;
                        });
                } else {
                    if (routeDestSection === "LoginCenter" || routeDestSection === "LogoutCenter") {
                        return true;
                    } else {
                        throw new Error("No credentials provided");
                    }
                }
            })
            .catch((err) => {
                this._localStorage.setToken(null);
                if (
                    location.href.toLowerCase().search("login") < 0 &&
                    location.href.toLowerCase().search("logout") < 0 &&
                    location.href.toLowerCase().search("fail") < 0 &&
                    location.href.toLowerCase().search("banner") < 0 &&
                    location.href.toLowerCase().search("eula") < 0 &&
                    location.href.toLowerCase().search("robohelp") < 0 &&
                    location.href.toLowerCase().search("passwordreset") < 0 &&
                    !window.localStorage.getItem("loadpath", location.href) &&
                    isValidUrlForStorage(location.href)
                ) {
                    window.localStorage.setItem("loadpath", location.href);
                }
                let dest = {app: "GameConsole", s: "LoginCenter", rd: {triggeredBy: "Startup"}};

                if (routeDestSection === "PasswordReset") {
                    this._muf.displayNotification(
                        "The password reset email link has expired. Please contact your administrator to request a new password reset email.",
                        {
                            notDismissable: true,
                            title: "Invalid Password-Reset Key",
                            confirmDetails: {text: "Continue"},
                        }
                    );
                } else {
                    if (routeDestSection) {
                        dest.rd.redirect = redirect;
                    } else if (_.get(opts, "newRouteDetails.sln", false) === "classic") {
                        dest.rd.redirect = {sln: "classic"};
                    }
                }
                this._logger.warn(
                    {error: err},
                    "ShowHomeBarAppendage.startUp() - Unable to automatically login, routing to login screen"
                );

                this._router.goTo(dest);
                return false;
            });
    }
}

module.exports = StartupAppendage;
module.exports.$inject = [
    "$teve.logger",
    "$teve.core",
    "$teve.userSession",
    "$teve.router",
    "$teve.ui.userFeedback",
    "$teve.userLocalStorage",
    "$teve.entities.ControlUser",
];
